/*
	@ Welcome popup

	# days - set timeout in days
*/

var now, lastDatePopupShowed, days, exist
now = new Date()
days = 1
exist = $('#welcomepopup').length


function initWelcomePopup(){
	setTimeout(function(){
			$.magnificPopup.open({
				items: {
					src: '#welcomepopup'
				},
				type: 'inline',
				closeOnBgClick: false,
				removalDelay: 300,
				mainClass: 'mfp-fade'
			});
		}, 0)
}

if(exist){
	if (localStorage.getItem('lastDatePopupShowed') !== null) {
		lastDatePopupShowed = new Date(parseInt(localStorage.getItem('lastDatePopupShowed')));
	}

	if (((now - lastDatePopupShowed) >= (days * 86400000)) || !lastDatePopupShowed) {
		initWelcomePopup()
		localStorage.setItem('lastDatePopupShowed', now);
	}
}
